import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useQuery } from 'react-query';
import { getDeals } from '@general/api/shared';

const getChatUsers = async graphID => {
    const response = await getDeals({ endpoint: `chat-users/${graphID}` });
    return response.data;
};

// Someone could send you a message at any time, how often to check if a user is created?
// This checks every minute for testing
// Should this be a web socket?
// The `graphID &&` triggers an error in the console: `Missing queryFn`, but it's not fatal
const useChatUserExists = graphID => {
    const [refetchInterval, setRefetchInterval] = useState(60 * 1000);
    return useQuery(graphID && [`chat-user-exists`, graphID], () => getChatUsers(graphID), {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchInterval,
        onSuccess: data => {
            if (data.data.identity === null) return;
            setRefetchInterval(Infinity);
        },
    });
};

useChatUserExists.propTypes = {
    graphID: PropTypes.string,
};

export default useChatUserExists;
